const parseXhrPayload = (xhr) => {
  const contentType = xhr.getResponseHeader('content-type') || '';
  if (!xhr.responseText) return null;
  if (contentType.includes('application/json')) {
    try {
      return JSON.parse(xhr.responseText);
    } catch {
      return xhr.responseText;
    }
  }
  return xhr.responseText;
};

export const uploadWithProgress = (url, {
  method = 'POST',
  body,
  headers = {},
  onProgress,
  signal,
  timeout = 0,
} = {}) => new Promise((resolve, reject) => {
  if (signal?.aborted) {
    reject(signal.reason || new DOMException('Upload cancelled', 'AbortError'));
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);
  xhr.timeout = timeout;
  const abort = () => xhr.abort();
  const cleanup = () => signal?.removeEventListener('abort', abort);

  Object.entries(headers).forEach(([name, value]) => {
    if (value != null && value !== '') {
      xhr.setRequestHeader(name, value);
    }
  });

  if (typeof onProgress === 'function' && xhr.upload) {
    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable || !event.total) return;
      onProgress(Math.round((event.loaded * 100) / event.total));
    };
  }

  xhr.onload = () => {
    cleanup();
    const data = parseXhrPayload(xhr);
    if (xhr.status >= 200 && xhr.status < 300) {
      resolve({ status: xhr.status, data });
      return;
    }
    const error = new Error(`Upload failed (${xhr.status})`);
    error.status = xhr.status;
    error.data = data;
    reject(error);
  };

  xhr.onerror = () => {
    cleanup();
    reject(new Error('Could not upload the file. Check your connection and retry.'));
  };
  xhr.ontimeout = () => {
    cleanup();
    reject(new Error('The upload took too long. Please retry.'));
  };
  xhr.onabort = () => {
    cleanup();
    reject(signal?.reason || new DOMException('Upload cancelled', 'AbortError'));
  };
  signal?.addEventListener('abort', abort, { once: true });
  try {
    xhr.send(body);
  } catch (error) {
    cleanup();
    reject(error);
  }
});
